import React, { createContext, useContext, useState, useEffect } from 'react'

const MarketContext = createContext()

export const useMarket = () => useContext(MarketContext)

export const MARKET_REGIONS = {
  gb: { currency: 'GBP', symbol: '£', essentialPrice: '49', premiumPrice: '99', businessPrice: '199', path: '/pricing' },
  us: { currency: 'USD', symbol: '$', essentialPrice: '59', premiumPrice: '125', businessPrice: '250', path: '/pricing' },
  au: { currency: 'AUD', symbol: 'A$', essentialPrice: '100', premiumPrice: '205', businessPrice: '415', path: '/pricing' },
  ae: { currency: 'AED', symbol: 'AED', essentialPrice: '225', premiumPrice: '455', businessPrice: '925', path: '/pricing' },
  eu: { currency: 'EUR', symbol: '€', essentialPrice: '59', premiumPrice: '115', businessPrice: '235', path: '/pricing' }
}

export function MarketProvider({ children }) {
  const [market, setMarketState] = useState('gb')

  useEffect(() => {
    if (typeof window === 'undefined') return

    // 1. Check path prefix/suffix first
    const path = window.location.pathname
    let initialMarket = null
    
    if (path.includes('/pricing-us') || path.includes('/us/') || /-us\/$/.test(path)) {
      initialMarket = 'us'
    } else if (path.includes('/pricing-gb') || path.includes('/gb/')) {
      initialMarket = 'gb'
    } else if (path.includes('/pricing-au') || path.includes('/au/')) {
      initialMarket = 'au'
    } else if (path.includes('/pricing-ae') || path.includes('/ae/')) {
      initialMarket = 'ae'
    } else if (path.includes('/pricing-eu') || path.includes('/eu/')) {
      initialMarket = 'eu'
    }

    // 2. Check localStorage
    if (!initialMarket) {
      initialMarket = localStorage.getItem('collar_market')
    }

    // 3. Geolocation fallback
    if (!initialMarket) {
      fetch('https://cloudflare.com/cdn-cgi/trace')
        .then(res => res.text())
        .then(data => {
          const locLine = data.split('\n').find(line => line.startsWith('loc='))
          if (locLine) {
            const country = locLine.split('=')[1].toUpperCase()
            let detectedMarket = 'gb'
            if (country === 'US') {
              detectedMarket = 'us'
            } else if (country === 'AU') {
              detectedMarket = 'au'
            } else if (country === 'AE') {
              detectedMarket = 'ae'
            } else if (['AT','BE','CY','EE','FI','FR','DE','GR','IE','IT','LV','LT','LU','MT','NL','PT','SK','SI','ES'].includes(country)) {
              detectedMarket = 'eu'
            }
            setMarketState(detectedMarket)
            localStorage.setItem('collar_market', detectedMarket)
          }
        })
        .catch(err => {
          console.error('Geo IP detection failed:', err)
          setMarketState('gb')
        })
    } else {
      setMarketState(initialMarket)
      localStorage.setItem('collar_market', initialMarket)
    }
  }, [])

  const changeMarket = (newMarket) => {
    if (MARKET_REGIONS[newMarket]) {
      setMarketState(newMarket)
      if (typeof window !== 'undefined') {
        localStorage.setItem('collar_market', newMarket)
      }
    }
  }

  return (
    <MarketContext.Provider value={{ market, setMarket: changeMarket, regions: MARKET_REGIONS }}>
      {children}
    </MarketContext.Provider>
  )
}
